module.exports = __webpack_public_path__ + "img/Flag_of_Senegal.4db98c0b.svg";